import type { SVGProps } from 'react';
const DawnFlagBY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-BY_svg__a)">
      <path fill="#E54252" d="M0 10.667h22V0H0z" />
      <path fill="#5CBE6B" d="M0 16h22v-5.333H0z" />
      <path
        fill="#fff"
        d="M0 0h3.143v2.4l-.524.8.524.8v1.6l-.524.8.524.8v1.6l-.524.8.524.8V12l-.524.8.524.8V16H0z"
      />
      <path
        fill="#E54252"
        d="M-.524 1.6-1.57 3.2l1.047 1.6L.524 3.2zm0 3.2L-1.57 6.4-.524 8-1.57 9.6l1.047 1.6L.524 9.6-.524 8 .524 6.4zm0 6.4-1.047 1.6 1.047 1.6 1.048-1.6z"
      />
      <path
        fill="#E54252"
        d="M.523 1.6 1.571 0 2.62 1.6 1.57 3.2zm1.048 4.8L.523 4.8l1.048-1.6L2.62 4.8zm0 0L2.62 8 1.57 9.6.523 8zM.523 11.2l1.048-1.6 1.048 1.6-1.048 1.6zm1.048 1.6 1.048 1.6L1.57 16 .523 14.4z"
      />
    </g>
  </svg>
);
export default DawnFlagBY;
